import type { Variant, Direction } from "./floatingButtonTypes";

const directions: Record<Direction, string> = {
  "top-right": "top-0 right-0 -translate-x-6 translate-y-6",
  "bottom-right":
    "bottom-0 right-0 -translate-x-4 md:-translate-x-6 -translate-y-4 md:-translate-y-6",
  "top-left": "top-0 left-0 translate-x-6 translate-y-6",
  "bottom-left": "bottom-0 left-0 translate-x-6 -translate-y-6",
};

const variant: Record<Variant, string> = {
  default:
    "bg-background shadow-sm rounded-full ring-1 ring-border p-3 cursor-pointer",
  ghost:
    "bg-background shadow-sm rounded-full ring-1 ring-border p-3 cursor-pointer",
  secondary:
    "bg-background shadow-sm rounded-full ring-1 ring-border p-3 cursor-pointer",
  destructive:
    "bg-background shadow-sm rounded-full ring-1 ring-border p-3 cursor-pointer",
  link: "bg-background shadow-sm rounded-full ring-1 ring-border p-3 cursor-pointer",
  "outline-solid":
    "bg-background shadow-sm rounded-full ring-1 ring-border p-3 cursor-pointer",
};

export { directions, variant };
